module.exports = __webpack_public_path__ + "img/calendario.93b654ff.svg";